import { styled } from '@mui/material/styles';
import { Menu } from '@mui/material';
import { getThemeColor } from '../../../utils/styleUtils';

export const StyledMenu = styled(Menu)(({ backgroundcolor, theme, maxWidth, minWidth, onClose }) => ({
  '& .MuiMenu-paper': {
    borderRadius: '20px',
    padding: '32px',
    ...(backgroundcolor
      ? { backgroundColor: getThemeColor(backgroundcolor, theme) }
      : {}),
  },
  '& .MuiPaper-root': {
    onMouseOut: onClose,
    maxWidth: maxWidth,
    marginLeft: '-32px',
    minWidth: minWidth,
    boxSizing: 'border-box'

  },
  '& .MuiBox-root': {
    '& .MuiTypography-h6': {
      fontSize: '0.968em',
      fontWeight: '700'
    },
    '& .MuiTypography-body1': {
      fontSize: '0.742em',
      fontWeight: '500',
      lineHeight: '1.2'
    },
    '& .MuiButton-root': {
      fontSize: '0.742em'
    }
  },
}));
